// Styles for Quote go here.
import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledQuote = styled.div`
  .luxury-quote {
    padding: ${toRem(64)} 0;
    align-items: center;
    p {
      margin-bottom: 0;
      display: inline;
    }

    .luxury-quote-image {
      width: 100%;
      aspect-ratio: 2/3;
    }
  }

  [dir='rtl'] & {
    text-align: right;
    q.reverse-quotes {
      quotes: '”' '“';
    }
    .right-ar-image {
      margin-left: 0;
    }
    .left-ar-text {
      margin-left: 0;
    }
  }
`;
